<template>
  <q-dialog v-model="shown">
    <q-card style="width: 400px;">
      <q-form
        ref="formRef"
      >
        <q-card-section class="row items-center q-mx-xs">
          <div class="text-h6">
            Create New Circuit
          </div>
          <q-space />
          <q-btn
            v-close-popup
            icon="close"
            flat
            round
            dense
          />
        </q-card-section>
        <q-card-section>
          <div
            class="row q-col-gutter-sm items-start"
          >
            <q-select
              v-model="developer.circuitTemplateId"
              class="col-12"
              label="Starting Template"
              :options="developer.circuitTemplateOptions"
              :rules="[val => val !== undefined || 'Selection is required']"
              map-options
              emit-value
              bottom-slots
            />
            <q-input
              v-model="developer.newCircuitName"
              class="col-6"
              label="Circuit Name"
              :rules="[val => !!val || 'Value is required']"
              bottom-slots
            />
            <q-input
              v-model="developer.newSiteName"
              class="col-6"
              label="Site Name"
              :rules="[val => !!val || 'Value is required']"
              bottom-slots
            />
            <q-checkbox
              v-model="developer.createConsumerWebsite"
              class="col-12 q-pt-sm"
              label="Create Consumer Website"
              bottom-slots
            />
          </div>
        </q-card-section>
        <q-card-section>
          <div
            class="row"
          >
            <q-btn
              size="lg"
              class="col-12"
              color="negative"
              label="Create New Circuit"
              :loading="creating"
              @click="create"
            />
          </div>
        </q-card-section>
      </q-form>
    </q-card>
  </q-dialog>
</template>

<script>
import FormValidationMixin from 'src/modules/admin/mixins/FormValidationMixin'

export default {
  name: 'CreateCircuitDialog',
  mixins: [FormValidationMixin],
  props: {
    modelValue: {
      type: Boolean,
      required: false
    }
  },
  emits: ['update:model-value'],
  data () {
    return {
      shown: false,
      creating: false
    }
  },
  watch: {
    modelValue () {
      this.shown = this.modelValue
    },
    shown () {
      this.$emit('update:model-value', this.shown)
    }
  },
  models: {
    developer: {
      circuitTemplates: {
        fields: ['id', 'name']
      },
      immediate: true
    }
  },
  methods: {
    create () {
      this.validateForm(async () => {
        this.creating = true

        this.developer.action = 'create_new_circuit'
        const result = await this.developer.save()

        if (result.errors.length) {
          this.$mh.showErrors(result.errors)
          this.creating = false
          return
        }

        await this.$handleAuthChange()

        this.creating = false
        this.shown = false
      })
    }
  }
}

</script>
